(function ($, Drupal, once) {
  Drupal.behaviors.accordionTabs = {
    attach: function attach(context, settings) {
      once('accordionTabs', '.accordion-tabs-content-wrapper', context).forEach(element => {
        $(element).on('click', function(e) {
          // Only proceed if clicking on the summary element
          if (e.target.closest('summary')) {
            const accordionContainer = $(this).closest('.accordion-tabs-accordion');
            const tabIndex = $(this).data('tab-index');
            const imageWrapper = $(this).closest('.accordion-tabs-wrapper').find('.accordion-tabs-image');
            
            // If this details is being opened
            if (!this.open) {
              // Close all other details
              accordionContainer.find('details').not(this).removeAttr('open');
              
              // Hide all images
              imageWrapper.find('> div').hide();
              // Show the corresponding image
              imageWrapper.find(`> div[data-image-index="${tabIndex}"]`).show();
            } else {
              // If this details is being closed
              // Hide the corresponding image
              imageWrapper.find(`> div[data-image-index="${tabIndex}"]`).hide();
            }
          }
        });
      });

      // Initialise the first image on page load
      once('accordionTabsInit', '.accordion-tabs-wrapper', context).forEach(wrapper => {
        const openDetails = $(wrapper).find('details[open]').first();
        if (openDetails.length) {
          const tabIndex = openDetails.data('tab-index');
          $(wrapper).find(`.accordion-tabs-image > div[data-image-index="${tabIndex}"]`).show();
        } else {
          // Hide all images if no details are open
          $(wrapper).find('.accordion-tabs-image > div').hide();
        }
      });
    }
  };
})(jQuery, Drupal, once);